function legalButtonHandler() {
    const hiddenField = $('#hfdLegalProfile');
    const selector = '#edit-legal-button';
    $(selector).off('click');
    $(selector).on('click' , () => {
        $('#legalProfileMaskContainer').fadeOut();
        hiddenField.val('true');
        updateLegalCheckbox();
    });
}

function legalProfileCheckboxHandler() {
    const hiddenField = $('#hfdLegalProfile');
    const icon = $('#profileLegalCheckboxIcon');
    const selector = '#profileLegalCheckbox';
    $(selector).off('click');
    $(selector).on('click', () => {
        if (hiddenField.val() === 'false') {
            hiddenField.val('true');
            setValidators(true);
            setInputs(false);
        } else {
            hiddenField.val('false');
            setValidators(false);
            setInputs(true);
        }

        updateLegalCheckbox();
    });
}

function updateLegalCheckbox() {
    const icon = $('#profileLegalCheckboxIcon');
    const hiddenField = $('#hfdLegalProfile');
    if (hiddenField.val() === 'false') {
        icon.removeClass('fa-check-square');
        icon.addClass('fa-square-o');
    } else {
        icon.addClass('fa-check-square');
        icon.removeClass('fa-square-o');
    }

    updateValidators();
}

function updateValidators() {
    const hiddenField = $('#hfdLegalProfile');
    if (hiddenField.val() === 'false') {
        setValidators(false);
    } else {
        setValidators(true);
    }
}

function setValidators(enable) {
    const ids = [
        'requireValidatorCompanyName',
        'requireValidatorFinancialCode',
        'requireValidatorCompanyNationalId',
        'requireValidatorRegisterNumber',
        'regexValidatorCompanyAreaCode',
        'regexValidatorCompanyTelephone',
        'requireValidatorCompanyAreaCode',
        'requireValidatorCompanyTelephone'
    ];

    for (const id of ids) {
        const element = $('#' + id)[0];
        if (element) {
            (window as any).ValidatorEnable(element, enable);
            element.style.display = 'none';
        }
    }
}

function updateLegalProfileMask() {
    const hiddenField = $('#hfdLegalProfile');
    if (hiddenField.val() === 'true') {
        $('#legalProfileMaskContainer').hide();
    }
}

function setInputs(enable) {
    $('#legalProfile input').prop('disabled', enable);
    $('#legalProfile select').prop('disabled', enable);
}

const initProfile = () => {
    legalButtonHandler();
    legalProfileCheckboxHandler();
    updateLegalCheckbox();
    updateLegalProfileMask();
};

export {
    initProfile
};
